<template>
  <b-modal v-model="isShow" @hide="onClose">
    <template #modal-title>
      {{ $t('Change Password') }}
    </template>
    <b-container fluid>
      <b-row class="mt-2 mb-4">
        <b-col>
          <b-form-input
            v-model="password"
            type="password"
            :placeholder="$t('New Password')"
            class="form-control-alternative"
          />
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <b-form-input
            v-model="passwordConfirm"
            type="password"
            :placeholder="$t('Confirm New Password')"
            class="form-control-alternative"
          />
        </b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100">
        <div class="float-right">
          <b-button
            variant="danger"
            size="sm"
            @click="change"
            :disabled="!changeButtonEnable"
          >
            {{ $t('Change') }}
          </b-button>
          <b-button variant="primary" size="sm" @click="ok">
            {{ $t('Cancle') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'PasswordPopup',
  data() {
    return {
      isShow: false,
      password: '',
      passwordConfirm: '',
      changeButtonEnable: false
    }
  },
  computed: {
    ...mapState(['passwordPopupData'])
  },
  methods: {
    ...mapMutations(['setUserPopupData']),
    change() {
      this.$emit('passwordHandler', _.trim(this.password))
    },
    onClose() {
      this.setUserPopupData({
        isShow: true
      })
      this.password = ''
      this.passwordConfirm = ''
      this.changeButtonEnable = false
    }
  },
  watch: {
    passwordPopupData() {
      if (this.passwordPopupData.isShow) {
        this.isShow = true
      }
    },
    password() {
      const p1 = _.trim(this.password)
      const p2 = _.trim(this.passwordConfirm)
      this.changeButtonEnable = p1.length && p1 === p2
    },
    passwordConfirm() {
      const p1 = _.trim(this.password)
      const p2 = _.trim(this.passwordConfirm)
      this.changeButtonEnable = p1.length && p1 === p2
    }
  }
}
</script>

<style scoped>
button.btn-danger {
  margin-right: 10px;
}
</style>
